// @ts-nocheck
import {
    BETS_MONITOR_REPORTS_DATA_CHANGED,
    SALES_REPORTS_CHANGED,
    BETS_MONITOR_REPORTS_DATA_CLEARED,
    SALES_FILTERS_CHANGED,
    ONLINE_PLAYERS_REPORT_CHANGED,
    ONLINE_PLAYERS_REPORT_CLEARED,
    FROZEN_ACCOUNTS_REPORT_DATA_CHANGED,
    FROZEN_ACCOUNTS_REPORT_DATA_CLEARED,
    REGISTRATIONS_HISTORY_REPORTS_CHANGED,
    REGISTRATIONS_HISTORY_REPORTS_CLEARED,
    SPORT_PERFORMANCE_DATA_CHANGED,
    SPORT_PERFORMANCE_DATA_CLEARED,
    MONEY_TRANSACTIONS_DATA_CHANGED,
    MONEY_TRANSACTIONS_DETAILS_CHANGED,
    MONEY_TRANSACTIONS_ALL_DATA_CLEARED,
    INACTIVE_PLAYERS_REPORT_DATA_CHANGED,
    INACTIVE_PLAYERS_REPORT_DATA_CLEARED,
    AUDIT_TRAIL_REPORT_DATA_CHANGED,
    AUDIT_TRAIL_REPORT_DATA_CLEARED,
    SPORT_PERFORMANCE_LOADING_CHANGED,
    TICKET_OPERATIONS_HISTORY_REPORTS_CHANGED,
    TICKET_OPERATIONS_HISTORY_REPORTS_CLEARED,
} from '../types';
import moment from 'moment';

const initialState = {
    ticketSales: {
        reports: [],
        summary: {},
        isFetching: false,
        filters: {
            isTestUser: false,
            agentId: '',
            dateRange: [moment().startOf('day'), moment().endOf('day')],
        },
    },
    betsMonitor: {
        reports: [],
        newReportIds: [],
        wonReportIds: [],
        cashOutReportIds: [],
        startedEventReportIds: [],
    },
    moneyTransactions: {
        reports: [],
    },
    moneyTransactionsDetails: {},
    gamingActivityFirstLevel: {
        reports: [],
        isFetching: false,
    },
    gamingActivitySecondLevel: {
        reports: {},
        isFetching: false,
    },
    onlinePlayers: {
        reports: [],
        summary: {},
    },
    registrationsHistory: {
        data: [],
        summary: {},
    },
    frozenAccountsList: [],
    sportsPerformanceData: {
        leagues: {
            topLeagues: [],
            bottomLeagues: [],
        },
        events: {
            topEvents: [],
            bottomEvents: [],
        },
        players: {
            topPlayers: [],
            bottomPlayers: [],
        },
    },
    isSportsPerformanceDataLoading: false,
    inactivePlayersReport: [],
    auditTrailReport: [],
    ticketOperationsHistory: {
        data: [],
    },
};

const reports = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case SALES_REPORTS_CHANGED: {
            return {
                ...state,
                ticketSales: {
                    ...state.ticketSales,
                    ...payload,
                },
            };
        }
        case SALES_FILTERS_CHANGED: {
            return {
                ...state,
                ticketSales: {
                    ...state.ticketSales,
                    filters: {
                        ...state.ticketSales.filters,
                        ...payload,
                    },
                },
            };
        }
        case BETS_MONITOR_REPORTS_DATA_CHANGED: {
            return {
                ...state,
                betsMonitor: {
                    ...state.betsMonitor,
                    ...payload,
                },
            };
        }
        case BETS_MONITOR_REPORTS_DATA_CLEARED: {
            return {
                ...state,
                betsMonitor: initialState.betsMonitor,
            };
        }
        case ONLINE_PLAYERS_REPORT_CHANGED: {
            return {
                ...state,
                onlinePlayers: {
                    ...state.onlinePlayers,
                    ...payload,
                },
            };
        }
        case ONLINE_PLAYERS_REPORT_CLEARED: {
            return {
                ...state,
                onlinePlayers: {
                    reports: [],
                    summary: {},
                },
            };
        }
        case FROZEN_ACCOUNTS_REPORT_DATA_CHANGED: {
            return {
                ...state,
                frozenAccountsList: payload,
            };
        }
        case FROZEN_ACCOUNTS_REPORT_DATA_CLEARED: {
            return {
                ...state,
                frozenAccountsList: initialState.frozenAccountsList,
            };
        }
        case REGISTRATIONS_HISTORY_REPORTS_CHANGED: {
            return {
                ...state,
                registrationsHistory: {
                    ...state.registrationsHistory,
                    ...payload,
                },
            };
        }
        case REGISTRATIONS_HISTORY_REPORTS_CLEARED: {
            return {
                ...state,
                registrationsHistory: initialState.registrationsHistory,
            };
        }
        case SPORT_PERFORMANCE_DATA_CHANGED: {
            return {
                ...state,
                sportsPerformanceData: {
                    ...state.sportsPerformanceData,
                    ...payload,
                },
                isSportsPerformanceDataLoading: false,
            };
        }
        case SPORT_PERFORMANCE_LOADING_CHANGED: {
            return {
                ...state,
                isSportsPerformanceDataLoading: payload,
            };
        }
        case SPORT_PERFORMANCE_DATA_CLEARED: {
            return {
                ...state,
                sportsPerformanceData: initialState.sportsPerformanceData,
            };
        }

        case MONEY_TRANSACTIONS_DATA_CHANGED: {
            return {
                ...state,
                moneyTransactions: {
                    ...state.moneyTransactions,
                    reports: payload,
                },
            };
        }
        case MONEY_TRANSACTIONS_DETAILS_CHANGED: {
            return {
                ...state,
                moneyTransactionsDetails: { ...state.moneyTransactionsDetails, ...payload },
            };
        }
        case MONEY_TRANSACTIONS_ALL_DATA_CLEARED: {
            return {
                ...state,
                moneyTransactions: initialState.moneyTransactions,
                moneyTransactionsDetails: initialState.moneyTransactionsDetails,
            };
        }
        case INACTIVE_PLAYERS_REPORT_DATA_CHANGED: {
            return {
                ...state,
                inactivePlayersReport: payload,
            };
        }
        case INACTIVE_PLAYERS_REPORT_DATA_CLEARED: {
            return {
                ...state,
                inactivePlayersReport: initialState.inactivePlayersReport,
            };
        }
        case AUDIT_TRAIL_REPORT_DATA_CHANGED: {
            return {
                ...state,
                auditTrailReport: payload,
            };
        }
        case AUDIT_TRAIL_REPORT_DATA_CLEARED: {
            return {
                ...state,
                auditTrailReport: initialState.auditTrailReport,
            };
        }
        case TICKET_OPERATIONS_HISTORY_REPORTS_CHANGED: {
            return {
                ...state,
                ticketOperationsHistory: {
                    ...state.ticketOperationsHistory,
                    data: payload,
                },
            };
        }
        case TICKET_OPERATIONS_HISTORY_REPORTS_CLEARED: {
            return {
                ...state,
                ticketOperationsHistory: initialState.ticketOperationsHistory,
            };
        }

        default:
            return state;
    }
};

export default reports;
